<template >
  <b-modal id="modalDockSchedules" class="modal-box" centered size="lg" ok-only>
      <div class="dock-schedules">
            <div class="dock-schedules--head row">
                <div class="col-lg-7">
                  <h3>Schedule Table for : <strong>{{selectedDock.name}}</strong> </h3>
                </div>
                <div class="col-lg-5">
                  <button v-if="shipyard.company.email || shipyard.account.email" class="btn" @click="askAvaibility()">Request Detail Schedule</button>
                </div>

            </div>
            <div class="legend mobile-only">

            </div>
          <table class="table" v-for="(month, m) in months" :key="m">
              <thead>
                  <tr class="table-success">
                      <th>{{month}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(week, w) in weeks" :key="w">
                      <td :class="{'blocked': !isAvailable(m, w)}">{{'Week ' + week}}</td>
                  </tr>
              </tbody>
          </table>
          <div class="legend desktop-only">
            <div class="avail">
              <p>Available</p>
            </div>
            <div class="not-avail">
              <p>Not Available</p>
            </div>
          </div>
      </div>
  </b-modal>
</template>

<script>
import miscAPI from "@/api/misc";
export default {
  props: ['selectedDock', 'shipyard'],
  data() {
    return {
      message: null,
      months: ['January', 'February', 'March', 'April', 'May', 'Juny', 'July', 'Augustus', 'September', 'October', 'November', 'December'],
      weeks: [1, 2, 3, 4]
    };
  },
  computed: {
    account() {
        let data = this.$store.state.account.account;

        if(data && data.type == 'user') data.detail = data.user;
        else if(data && data.type == 'shipyard') data.detail = data.shipyard;
        else if(data && data.type == 'vendor') data.detail = data.vendor;

        return data;
    },
  },
  methods: {
    isAvailable(m, w){
        return this.selectedDock.schedules.find(s => {
            return s.month == m+1 && s.week == w+1;
        })
    },
    askAvaibility() {
      let MiscApi = new miscAPI(this.$axios);
      if(this.account && this.account.user){
        MiscApi.askAvaibility({
          name: this.shipyard.name,
          email_to: this.shipyard.company.email || this.shipyard.account.email,
          username: this.account.user.name,
          email_sender: this.account.email,
        }).then(res => {
          this.$root.$emit("bv::show::modal", "success-modal");
          this.$root.$emit("bv::hide::modal", "modalDockSchedules");
        });
      } else {
          this.$root.$emit("bv::show::modal", "modalLogin");
      }
    }
  }
};
</script>

<style lang="scss">
@import "~/assets/scss/_mixins.scss";
@import "./style.scss";
</style>
